import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../utils/mockData';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const { language } = useLanguage();
  const content = mockData[language];

  return (
    <section id="home" className="relative min-h-screen flex items-start md:items-center overflow-hidden">
      {/* Desktop Background */}
      <div 
        className="absolute inset-0 hero-background hidden md:block"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/iri47kwe_fdsfdsfs%20%282%29.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      {/* Mobile Background */}
      <div 
        className="absolute inset-0 md:hidden"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/qvrbmtrz_sadsadsa.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center 60%'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/20"></div>
      </div>

      {/* Content - Left Aligned */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-16 w-full pt-32 pb-20">
        <div className="max-w-2xl space-y-6 animate-fade-in">
          {/* Title */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            {content.hero.titleLine1}
            <br />
            {content.hero.titleLine2}
            <br />
            <span className="text-teal-400">{content.hero.titleHighlight}</span>
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg md:text-xl text-gray-200 max-w-xl">
            {content.hero.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 pt-4">
            <Link
              to="/contact"
              className="px-8 py-3 bg-teal-600 hover:bg-teal-700 text-white font-semibold rounded-lg transition-colors shadow-lg"
            >
              {content.hero.ctaQuote}
            </Link>
            <Link
              to="/contact"
              className="px-8 py-3 border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold rounded-lg transition-colors"
            >
              {content.hero.ctaSamples}
            </Link>
          </div>

          {/* Certifications */}
          <div className="pt-6 pb-16 md:pb-0 space-y-2 text-gray-300 text-sm">
            <p>{content.hero.certifications1}</p>
            <p>{content.hero.certifications2}</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-0 right-0 z-20 animate-bounce">
        <div className="flex flex-col items-center justify-center space-y-2 text-white">
          <span className="text-sm font-light">{content.hero.scrollText}</span>
          <ChevronDown size={24} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
